import { Controller } from "@hotwired/stimulus"
import Masonry from "masonry-layout"
import imagesLoaded from "imagesloaded"
import { isHTMLElement } from "~/types/types.util"

// Connects to data-controller="masonry"
export default class extends Controller {
  static values = {
    gutter: Number,
    layoutComplete: Boolean,
  }

  declare gutterValue?: number
  private grid?: Masonry
  private observer?: MutationObserver

  connect() {
    this.grid = new Masonry(this.element, {
      percentPosition: true, // Enables percentage-based positioning
      gutter: this.gutterValue, // Optional: space between items
      transitionDuration: 0.1, // 0 duration breaks the layout
      columnWidth: this.element.querySelector(":scope > *:last-child"), // otherwise, deleting first child breaks layout
    })

    this.#handleImageLoading()

    // Observe any new elements that are added to the masonry to re-layout
    this.observer = new MutationObserver(this.#handleNewElements.bind(this))
    this.observer.observe(this.element, { childList: true })
  }

  layout() {
    this.grid?.reloadItems?.()
    this.grid?.layout?.()
    this.#handleImageLoading()
  }

  disconnect() {
    this.grid?.destroy?.()
  }

  #handleNewElements(mutations: MutationRecord[]) {
    mutations.forEach((mutation) => {
      const added = Array.from(mutation.addedNodes)
      const removed = Array.from(mutation.removedNodes)
      const htmlElements = [...added, ...removed].filter(isHTMLElement)
      if (htmlElements.length > 0) this.layout()
    })
  }

  #handleImageLoading() {
    imagesLoaded(this.element).on("progress", () => {
      // Everytime an image is loaded, we want to re-layout the grid
      this.grid?.layout?.()
    })
  }
}
